<template>
  <v-row>
    <v-col cols="12">
      <ReferenciasTable :referencias="referencias" />
    </v-col>
    <v-col cols="12">
      <APrimaryButton
        label="Cerrar"
        @click="CLOSE_DIALOG()"
      />
    </v-col>
  </v-row>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import APrimaryButton from '../atoms/APrimaryButton.vue';
import ReferenciasTable from './ReferenciasTable.vue';

export default {
  components: { APrimaryButton, ReferenciasTable },

  computed: {
    ...mapState({
      referencias: (state) => state.preregistro.referencias,
    }),
  },

  methods: {
    ...mapMutations('dialog', ['CLOSE_DIALOG']),
  },
};
</script>
